import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

const PaymentFailedPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      <Navbar />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-2xl border border-stone-200 shadow-lg p-12 text-center"
          data-testid="payment-failed-container"
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-rose-100 text-rose-600 mb-6"
          >
            <XCircle className="h-12 w-12" />
          </motion.div>

          <h1 className="text-4xl font-serif font-bold text-stone-800 mb-4" data-testid="failed-title">
            Payment Failed
          </h1>
          <p className="text-lg text-stone-600 mb-8">
            We couldn't process your payment. Please try again or contact us for assistance.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={() => navigate("/order")}
              className="rounded-full bg-amber-600 hover:bg-amber-700 text-white px-8 py-6"
              data-testid="try-again-button"
            >
              Try Again
            </Button>
            <Button
              onClick={() => navigate("/")}
              variant="outline"
              className="rounded-full border-amber-200 hover:border-amber-400 px-8 py-6"
              data-testid="back-home-button-failed"
            >
              Back to Home
            </Button>
          </div>
        </motion.div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentFailedPage;
